// React
import { memo } from "react";

// Custom Components

import PriceListInfoCard from "../PriceListInfoCard/PriceListInfoCard";

// Types
import { PriceListDetailProps } from "./types";

const PriceListDetailCard: React.FC<PriceListDetailProps> = (props) => {
  const { priceListId } = props;

  return (
    <>
      <div className="flex gap-4">
        <div className="h-full ">
          <div className=" min-w-[400px]">
            <PriceListInfoCard priceListId={priceListId} />
          </div>
        </div>
        <div className="h-full flex flex-1 flex-col gap-4">
          <div className="">
   
          </div>
        </div>
      </div>
    </>
  );
};
export default memo(PriceListDetailCard);
